interface RGB {
    red: number;
    green: number;
    blue: number;
}

// long hex - 7 digits. Example: #ffffff
// shot hex - 4 digits. Example: #fff
// hexCode - without '#'. Example: fff, ffffff

export default function convertHexToRgb(hexClr: string): RGB | Error {
    const isShortHex = hexClr.length === 4;
    const isLongHex = hexClr.length === 7;

    if ((!isShortHex && !isLongHex) || hexClr[0] !== '#')
        return new Error(`Color hex value is incorrect: "${hexClr}"`);

    const hexCode = hexClr.slice(1);
    const longHexCode = isLongHex
        ? hexCode
        : convertShortToLongHexCode(hexCode);

    return {
        red: parseInt(longHexCode.substr(0, 2), 16),
        green: parseInt(longHexCode.substr(2, 2), 16),
        blue: parseInt(longHexCode.substr(4, 2), 16),
    };
}

function convertShortToLongHexCode(shortHexCode: string): string {
    return shortHexCode
        .split('')
        .map(letter => letter.repeat(2))
        .join('');
}
